<template lang="pug">
  transition()
    div()
      .HeaderSearchInput(:class="{ 'HeaderSearchInput-open': isOpen }" v-if="isVisible")

        .HeaderSearchInput_toggler(@click="toggleSearch")
          svg(width='26', height='26').magnifier
            g(transform='translate(1 1)', stroke='#FFEFCE', stroke-width='2', fill='none', fill-rule='evenodd')
              circle(cx='10', cy='10', r='10')
              path(d='M17.75 17.75L23 23', stroke-linecap='square')

          form(method="POST", action="", autocomplete="off", @submit.prevent="submit", :class="{ 'is-disabled': processing }")
            input.search#HeaderSearchInput(type="text"
                                          ref="search"
                                          name="input"
                                          :placeholder="$t('menu.search.placeholderBase')",
                                          autocorrect="off"
                                          autocapitalize="off"
                                          autocomplete="off"
                                          spellcheck="false"
                                          v-model="query"
                                          @keydown.down.stop="arrowDown"
                                          @keydown.up.stop="arrowUp"
                                          @keydown.enter.stop.prevent="enter")
            div(ref='placeholder').HeaderSearchInput_placeholder {{ $t('menu.search.placeholderBase') }}
            ul.HeaderSearchInput_auto(v-if="isFocus && isActive")
              li(v-for="(result, index) in results" @click="setQuery(result.name || result.drawer_subtitle)" :class="{ 'is-active': index === arrowCounter }") {{ result.name || result.drawer_subtitle }}
      .HeaderButtonMap(:class="{ 'HeaderButtonMap-active': !isSearchOpened }" @click="toggleSearchMap")
        span() {{$t('search.buttonMap')}}
        SvgInline(src="pin")
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { Component } from 'vue-instantsearch'
import i18n from '@/i18n'
import router from '@/router'
import SvgInline from '@/components/SvgInline'
import store from '@/store'

export default {
  mixins: [ Component ],
  components: { SvgInline },
  data () {
    return {
      processing: false,
      isOpen: false,
      isVisible: true,
      isActive: false,
      isActiveBtn: true,
      random: 0,
      isFocus: false,
      arrowCounter: 0,
      placeholder: this.$t('menu.search.placeholder')
    }
  },
  computed: {
    ...mapGetters(['isSearchOpened']),
    query: {
      get () {
        return this.isActive ? this.searchStore.query : ''
      },
      set (value) {
        if (this.$router.currentRoute.name === 'search') {
          this.isFocus = true
          this.searchStore.stop()
          this.searchStore.query = value
          this.$emit('query', value)
          // We here ensure we give the time to listeners to alter the store's state
          // without triggering in between ghost queries.
          this.$nextTick(function () {
            this.searchStore.start()
            this.searchStore.refresh()
          })
        }
      }
    },
    results () {
      return this.searchStore.results.slice(0, 10)
    }
  },
  watch: {
    $route (to, from) {
      this.updateInput()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('click', this.handleClickOutside)
    clearInterval(this.inverval)
    clearTimeout(this.timeout)
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    document.addEventListener('click', this.handleClickOutside)
    this.onResize()
    this.updateInput()
    if (this.isActive) {
      this.isActiveBtn = false
    }
  },
  methods: {
    ...mapActions(['setSearchQuery']),
    submit () {

    },
    updateInput () {
      this.isOpen = this.$router.currentRoute.name === 'home' || this.$router.currentRoute.name === 'search';
      this.isActive = this.$router.currentRoute.name === 'search'
    },
    handleClickOutside (e) {
      if (!this.$el.contains(e.target)) {
        this.isFocus = false
        this.arrowCounter = -1
      }
    },
    arrowDown () {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    arrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    enter () {
      this.query = this.results[this.arrowCounter].name
      this.isFocus = false
      this.arrowCounter = -1
    },
    setQuery (result) {
      this.query = result
      this.isFocus = false
    },
    focus () {
      this.isFocus = true
    },
    onResize () {
      if (window.innerWidth < 768 && !(this.$router.currentRoute.name === 'home' || this.$router.currentRoute.name === 'search')) {
        this.isVisible = false
        this.clearPlaceholder()
      } else {
        this.isVisible = true
      }
    },
    toggleSearch () {
      if (!this.isOpen) {
        this.isOpen = true
      }

      if (this.$router.currentRoute.name !== 'search') {
        this.isActive = true
        this.isActiveBtn = false
        router.push(i18n.locale === 'fr' ? '/fr/recherche' : '/en/search')
      }
    },
    toggleSearchMap () {
      store.dispatch('setSearchListType', false)
      this.toggleSearch()
    },
    closeSearch () {
      this.isOpen = false
      this.query = null
      this.isFocus = false
      this.isActive = false
      this.isActiveBtn = true
      // this.setSearchOpen(false)
      this.clearPlaceholder()
    },
    openSearch () {
      this.isOpen = true
    },
    placeholderTransition (string = this.$t('menu.search.placeholderBase'), delay = 0) {
      this.timeout = setTimeout(() => {
        if (this.$refs.search.value.length >= 1) return

        TweenMax.to('.HeaderSearchInput_placeholder', 0.6, {
          opacity: 0,
          x: 10,
          letterSpacing: 4,
          y: '-50%',
          onComplete: () => {
            this.$refs.placeholder.innerText = string
            this.random = this.random < (this.placeholder.length - 1) ? this.random += 1 : 0
            TweenMax.to('.HeaderSearchInput_placeholder', 0.6, { opacity: 1, x: 0, y: '-50%', letterSpacing: 2 })
          } })
      }, delay * 100)
    },
    clearPlaceholder () {
      clearInterval(this.inverval)
      clearTimeout(this.timeout)
      TweenMax.to('.HeaderSearchInput_placeholder', 0.2, { opacity: 0 })
    },
    randomPlaceholder () {
      if (this.$refs.search.value.length < 1) {
        this.placeholderTransition(this.placeholder[this.random], 0.4)

        this.inverval = setInterval(() => {
          this.placeholderTransition(this.placeholder[this.random])
        }, 2500)
      } else {
        this.clearPlaceholder()
      }
    }
  }
}

</script>

<style lang="stylus" scope>

.HeaderSearchInput
  z-index 15
  position fixed
  top 20px
  right 20px
  margin auto 0px auto auto
  background-color rgba(0,0,0,0.5)
  // box-sizing border-box
  border 2px solid $beige
  border-radius 50px
  display flex
  flex-direction row
  width 60px
  // overflow hidden
  backface-visibility hidden
  transition width 1s $ease, transform 0.6s $ease, opacity 0.6s $ease
  height 60px

  @media $mq_s_only
    height 45px
    width 45px

  @media $mq_m
    top 40px
    right 40px

  @media $mq_l
    top 50px
    right 50px

  &_placeholder

    font-size: 14px;
    letter-spacing 2px
    color: $beige
    top 50%
    opacity 0
    left 0px
    transform translateY(-50%)
    position absolute
    pointer-events none
    touch-action none
    box-sizing border-box
    padding 0px 40px
    transition letter-spacing 1.2s $ease

    @media $mq_m
      font-size: 16px;

    @media $mq_l
      font-size: 18px;

  &_auto

    position absolute
    top 120%
    box-sizing border-box
    border 2px solid $beige
    left -0.5%
    margin 0px
    background-color $black
    width 101%
    padding 0px
    max-height 50vh
    overflow-y auto

    li

      padding 10px 15px
      transition all 0.1s $ease
      color white
      font-size 15px
      &.is-active,
      &:hover
        background-color: $beige
        color: $black

  // ---
  // Animation d'apparition
  // ---
  &.v-enter, &.v-leave-to
    opacity: 0
    transform scale(0.3)

    img

      transform translateY(-50%) rotate(90deg)

  &.v-enter-active, &.v-leave-active
    transition all .6s $ease
  //--- fin animation

  &_toggler
    position: absolute
    cursor pointer
    top 0
    right 0
    bottom 0
    left 0
    border-radius 50px

  &:hover

    transform scale(0.9)
    opacity 0.7

  form

    width 100%
    display none
    height 100%
    flex-direction row
    position relative

  .search

    height 100%
    box-shadow none
    margin auto auto auto 0px
    appearance none
    color $beige
    background-color transparent
    padding 0px 40px
    font-size 14px
    box-sizing border-box
    width 100%

    @media $mq_s_only

      padding 0 0px 0px 20px

    @media $mq_m
      font-size: 16px;

    @media $mq_l
      font-size: 18px;

    &::placeholder

      font-size: 16px;
      color: $beige

      @media $mq_s_only

        font-size 14px

  .submit

    margin auto 0px auto auto
    width 100px
    height 100%
    appearance none
    position relative
    z-index 1
    padding 0px
    opacity 0
    cursor pointer

    @media $mq_s_only

      width 80px

  .magnifier

    top 50%
    position absolute
    right 16px
    transition left 0.8s $ease, right 0.8s $ease, transform 0.5s 0.5s cubic-bezier(0.77, 0, 0.175, 1);
    cursor pointer
    display block
    transform translateY(-50%) scale(0.85)

    @media $mq_s_only
      transform translateY(-50%) scale(0.8)
      right 10px

  &-open

    width calc(33.5% - 30px - 70px)
    box-sizing border-box

    @media $mq_m_only

      width calc(100% - 30px - 255px)
      max-width 300px

    @media $mq_s_only

      width calc(100% - 30px - 80px)

    &:hover

      opacity 1
      transform none

    form

      display flex

    .magnifier

      right 30px

      @media $mq_s_only

        right 20px

.HeaderButtonMap
  position fixed
  top 90px
  right 20px
  height 39px
  width 110px
  line-height 39px
  padding-left 15px
  border-radius 35px
  transition all 0.5s $ease
  cursor pointer
  border 2px solid $beige
  color $beige
  overflow hidden
  text-transform uppercase
  opacity 0
  visibility hidden
  z-index -1

  @media $mq_s_only
    height 39px
    width 100px

  @media $mq_m
    top 110px
    right 40px

  @media $mq_l
    top 120px
    right 50px

  &-active
    opacity 1
    visibility visible
    z-index 15
    background-color: rgba(0,0,0,.5)

  svg
    position absolute
    width 22px
    top 50%
    right -2px
    z-index 2
    transform translate(-50%, -50%)
    fill $black
    transition all 0.5s $ease

  &:before

    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 150%;
    height: 100%;
    background: white;
    z-index: -1;
    transform: rotate3d(0, 0, 1, -45deg) translate3d(0, 3em, 0);
    transform-origin: 100% 0%;
    transition: transform 0.3s, opacity 0.3s, background-color 0.3s;

  &:after
    content ''
    position absolute
    z-index 1
    width 35px
    height 35px
    top 2px
    right 2px
    border-radius 50%
    background-color $beige
    transition all 0.5s $ease

  &:hover, &.hover

    border-color transparent
    color $black
    // zoom : 98%;
    transform translateZ(0) perspective(1px)

    &:before

      opacity: 1;
      background-color: $beige;
      transform: rotate3d(0, 0, 1, 0deg);
      transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

  &:focus

    transform translateZ(0) perspective(1px)
    opacity 0.5

</style>
